export function delay(time) {
    return new Promise(r => setTimeout(r, time));
}
